module.exports = __webpack_public_path__ + "media/newstyle/images/icon-external-951022585fe05975d5a0bf2d697a15c5.svg";